document.addEventListener('DOMContentLoaded', () => {
  const input       = document.getElementById('SidebarSearchInput');
  const rootPane    = document.getElementById('menu-root');
  const searchPane  = document.getElementById('menu-search');
  const suggList    = document.getElementById('SearchSuggestions');
  const backBtn     = document.getElementById('SearchPaneBack');   // ➊  NEU
  let debounce;
  /* ----- Handles ---------------------------------------------------- */
const cardPrd = document.getElementById('CardProducts');
const cardCol = document.getElementById('CardCollections');
const cardArt = document.getElementById('CardArticles');

const listPrd = cardPrd.querySelector('ul');
const listCol = cardCol.querySelector('ul');
const listArt = cardArt.querySelector('ul');
const cardStatic    = document.getElementById('CardStatic');      // Häufig gesucht
const cardBest      = document.getElementById('CardBestseller');  // Bestseller

/* Sample-Filter */
const SAMPLE_RE = /^sample\s*-\s*/i;


  /* ---------- Pane-Switch ---------- */
 function activate(pane){
  const rootActive   = pane === rootPane;      // true ⇒ Hauptmenü sichtbar
  const searchActive = pane === searchPane;    // true ⇒ Such-Pane sichtbar

  /* Root-Pane */
  rootPane.classList.toggle('is-active', rootActive);
  rootPane.classList.toggle('is-left',  !rootActive);   // ← hier neu

  /* Search-Pane */
  searchPane.classList.toggle('is-active', searchActive);

  /* (optional) a11y - Status beibehalten */
  rootPane .setAttribute('aria-hidden', !rootActive);
  searchPane.setAttribute('aria-hidden', !searchActive);
}

  /* Fokus ⇒ Suche öffnen */
  input.addEventListener('focus',   () => activate(searchPane));

  /* ➋  Back-Button ⇒ zurück zum Root-Pane */
  backBtn.addEventListener('click', () => {
    input.value = '';
    suggList.innerHTML = '';
    activate(rootPane);
    input.blur();
  });

  /* Escape ⇒ gleiches Verhalten wie Back-Button */
  input.addEventListener('keydown', e => {
    if (e.key === 'Escape') backBtn.click();
  });

input.addEventListener('keydown', e => {
  if (e.key === 'Enter'){
    const q = input.value.trim();
    if (q) location.href = `/search?q=${encodeURIComponent(q)}`;
  }
});
  input.addEventListener('input', () => {

  clearTimeout(debounce);
  const q = input.value.trim();

  /* Kein Text ⇒ alte Static-Cards + Bestseller bleiben */
  if (!q){
    resetCards();            // dynamische Karten leeren / ausblenden
    cardStatic.hidden = false;
    cardBest.hidden   = false;
    renderStatic();         // „Häufig gesucht“ befüllen
    return;
  }
  cardStatic.hidden = true;
  cardBest.hidden   = true;
   

  debounce = setTimeout(async () => {
    const url = `/search/suggest.json?q=${encodeURIComponent(q)}`
              + `&resources[type]=product,collection,article`
              + `&limit=6`;

    const res  = await fetch(url, { headers:{'X-Requested-With':'XMLHttpRequest'} });
    const data = await res.json();
    resetCards();

    /* ---------- Produkte ---------- */
    const products = (data.resources.results.products || [])
                      .filter(p => !SAMPLE_RE.test(p.title));
    if (products.length){
      listPrd.innerHTML = products.map(p =>
        `<li><a class="MenuCard__Link" href="${p.url}">
              <img src="${p.image}" width="32" height="32" style="vertical-align:middle;border-radius:4px;margin-right:.5rem;">
              ${p.title}
          </a></li>`
      ).join('');
      cardPrd.hidden = false;
    }

    /* ---------- Kollektionen ---------- */
    const cols = data.resources.results.collections || [];
    if (cols.length){
      listCol.innerHTML = cols.map(c =>
        `<li><a class="MenuCard__Link" href="${c.url}">${c.title}</a></li>`
      ).join('');
      cardCol.hidden = false;
    }

    /* ---------- Artikel ---------- */
    const arts = data.resources.results.articles || [];
    if (arts.length){
      listArt.innerHTML = arts.map(a =>
        `<li><a class="MenuCard__Link" href="${a.url}">${a.title}</a></li>`
      ).join('');
      cardArt.hidden = false;
    }

    /* Falls gar nichts kam – Anzeige leer halten, Static wieder zeigen */
    if (cardPrd.hidden && cardCol.hidden && cardArt.hidden) renderStatic();

  }, 250);
});

  /* Renderer */
  const STATIC = ['Vitamin C Serum','Hyaluron','Retinol','Sonnenschutz','Anti-Aging','Akne','Faltencreme','Cleanser','Augencremes'];
  function render(arr){
    suggList.innerHTML = arr.map(t =>
      `<li><button class="MenuCard__Link"
                   onclick="location.href='/search?q=${encodeURIComponent(t)}'">${t}</button></li>`
    ).join('');
  }
  const renderStatic = () => render(STATIC);
  renderStatic();
  
  function resetCards(){
  [cardPrd, cardCol, cardArt].forEach(card => {
    card.hidden = true;
    card.querySelector('ul').innerHTML = '';
  });
}
});
